import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from 'lib/utils';

const Tabs = TabsPrimitive.Root;

/**
 * 탭 트리거 — 기본은 underline 스타일 (DESIGN.md §7 권장).
 * 활성 탭은 navy-700 보더 + 텍스트, 비활성은 neutral-500.
 */
const TabsList = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            // 하단 기준선은 inset shadow — border + 자식 -mb-px 조합은 overflow 컨테이너에서 세로 스크롤바를 만든다
            'inline-flex h-10 w-full items-center gap-6 shadow-[inset_0_-1px_0_hsl(var(--border))]',
            className
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'relative inline-flex items-center gap-2 h-10 px-1 text-md font-medium text-neutral-500 transition-colors duration-fast',
            'border-b-2 border-transparent',
            'hover:text-foreground',
            'focus-visible:outline-none focus-visible:text-foreground',
            'disabled:pointer-events-none disabled:text-neutral-400',
            'data-[state=active]:text-foreground data-[state=active]:border-primary',
            className
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn(
            'mt-4 focus-visible:outline-none',
            className
        )}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
